<div class="kpi-grid mb--md">
  <app-kpi-tile
    [label]="'App.Admin.Dashboard.Labels.Total' | translate"
    [value]="totals.total.value"
    [diffPercent]="totals.total.diffPercent"
    [diffAbsolute]="totals.total.diffAbsolute">
  </app-kpi-tile>
  <app-kpi-tile
    [label]="'App.Charts.dropOff' | translate"
    [value]="totals.dropOff.value"
    [diffPercent]="totals.dropOff.diffPercent"
    [diffAbsolute]="totals.dropOff.diffAbsolute">
  </app-kpi-tile>
  <app-kpi-tile
    [label]="'App.Charts.hal' | translate"
    [value]="totals.hal.value"
    [diffPercent]="totals.hal.diffPercent"
    [diffAbsolute]="totals.hal.diffAbsolute">
  </app-kpi-tile>
  <app-kpi-tile
    [label]="'App.Charts.subscription' | translate"
    [value]="totals.subscription.value"
    [diffPercent]="totals.subscription.diffPercent"
    [diffAbsolute]="totals.subscription.diffAbsolute">
  </app-kpi-tile>
  <app-kpi-tile
    [label]="'App.Charts.outbound' | translate"
    [value]="totals.outbound.value"
    [diffPercent]="totals.outbound.diffPercent"
    [diffAbsolute]="totals.outbound.diffAbsolute">
  </app-kpi-tile>
</div>
